export default __webpack_public_path__ + "static/fox-search-93afa842100edd4e9b679dc836031248.png";